import { FC } from 'react'
import {
  MenuItemContainer,
  MenuTitle,
  MenuSubtitle,
  MenuArrow,
  BackgroundImage,
  ImageWrapper,
} from './styled'
type Props = {
  title: string
  subtitle: string
  id: number
  background: string
  onClick: (index: number) => void
  backgroundAnimation?: [number, number]
}
/*const handleClick = (index: number) => {
  console.log(document.getElementById("chapter-" + index));
  document.getElementById("chapter-" + index)?.scrollIntoView();
};*/
export const MenuItem: FC<Props> = ({
  title,
  subtitle,
  id,
  background,
  backgroundAnimation,
  onClick,
}) => {
  return (
    <MenuItemContainer
      onClick={(event: any) => {
        onClick(id + 1)
      }}
    >
      <ImageWrapper>
        <BackgroundImage
          src={background}
          $backgroundAnimation={backgroundAnimation}
        />
      </ImageWrapper>
      <MenuTitle>{title}</MenuTitle>
      <MenuSubtitle>{subtitle}</MenuSubtitle>
      <MenuArrow />
    </MenuItemContainer>
  )
}
